<!-- ユーザー情報 -->
<template>
  <div class="input-filed--container">
    <!-- 名前入力 -->
    <div class="input-field--content input-field--content__name">
      <label for="NAME">{{ $t('yourInformation.name') }}</label>
      <input
        type="text"
        v-model="NAME"
        :class="{ 'invalid':errors.has('NAME')}"
        name="NAME"
        v-validate="'required'"
        :placeholder="$t('yourInformation.putName')"
        class="input"
      />
    </div>
    <div class="invalid-text" v-show="errors.has('NAME')">{{ $t('validation.requiredText') }}</div>

    <!-- 性別入力: 選択 -->
    <div class="input-field--content input-field--content__sex">
      <label for="sex">{{ $t('yourInformation.gender') }}</label>
        <div class="input-field--content__sex--content">
          <input type="radio" v-model.number="SEX" name="sex" :value="1" id="men"
          v-validate="'required|included:1,2'" />
          <label for="men">{{ $t('yourInformation.men') }}</label>
        </div>
        <div class="input-field--content__sex--content">
          <input type="radio" v-model.number="SEX" name="sex" :value="2" id="women" />
          <label for="women">{{ $t('yourInformation.women') }}</label>
        </div>
    </div>
    <!--性別選択要求文-->
    <div class="invalid-text" v-show="errors.has('sex')">{{ $t('validation.requiredText') }}</div>

    <!--年齢入力-->
    <div class="input-field--content input-field--content__age">
      <label for="age">{{ $t('yourInformation.age') }}</label>
      <input
        type="number"
        v-model.number="AGE"
        name="age"
        :class="{ 'invalid': errors.first('age')}"
        v-validate="'required|between:20,80'"
        class="input"
        min="20"
        max="80"
      />
      <div class="unit">{{ $t('yourLifestyle.yearsOld') }}</div>
    </div>
    <div class="invalid-text" v-show="errors.first('age')">{{ $t('validation.requiredText') }}</div>
    <!--次えボタン-->
    <next-button
      @click="clickNextButton"
      :disabled="isDisable"
      :label="$t('common.next')"
      class="button__next"
    />
  </div>
</template>

<script>
import NextButton from "../../components/atoms/NextButton";

export default {
  name: "userInfo",
  components: {
    NextButton
  },
  computed: {
    NAME: {
      set(val) {
        this.$store.commit("aiPrediction/setNAME", val);
      },
      get() {
        return this.$store.state.aiPrediction.karteData.name;
      }
    },
    SEX: {
      set(val) {
        this.$store.dispatch("aiPrediction/setSEX", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getSEX"];
      }
    },
    AGE: {
      set(val) {
        this.$store.dispatch("aiPrediction/setAGE", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getAGE"];
      }
    },
    isDisable() {
      let bool = Object.keys(this.fields).some(key => this.fields[key].invalid);
      this.$store.dispatch("validations/setUserInfo", bool);
      return bool;
    }
  },
  methods: {
    clickNextButton() {
      this.$emit("increment");
    }
  },
  created() {
    //スクロールの位置を初期化；　indexをページトップにする処理
    scrollTo(0,0);
    let gender = Number(this.$store.getters["users/getGender"]);
    this.$store.dispatch(
      "aiPrediction/setNAME",
      this.$store.getters["users/getNickname"]
    );
    this.$store.dispatch("aiPrediction/setSEX", gender);
  }
};
</script>

<style scoped>
.input-filed--container {
  width: 100%;
  margin: 0 auto;
}

.input {
  border-radius: 5px;
  border: 1px solid #ced4da;
  padding: 5px;
  height: 40px;
}
.input-field--content {
  display: grid;
  align-items: center;
  gap: 20px;
  margin-top: 40px;
  grid-template-columns: 1fr 4.5fr 4.5fr;
}
.input-field--content__name > input {
  grid-column: span 2;
}
.input-field--content__sex--content {
  display: flex;
  align-items: center;
}
.input-field--content__sex--content > label {
  margin-left: 20px;
}
.input-field--content__age > .unit {
  justify-self: start;
}

.button__next {
  margin-top: 40px;
}

.invalid {
  border-color: red;
}
.invalid-text{
  color:red;
}
input {
  border-radius: 2px;
  height: 30px;
  font-size: calc(100% + 0.25vw);
}
</style>
